import { Loader, LoaderProps } from "semantic-ui-react";

type BPLoaderProps = LoaderProps & {}
export function BPLoader(props: BPLoaderProps) {
    return <Loader {...props}>{props.children}</Loader>;
}